module.exports = __webpack_public_path__ + "static/media/newOrder.db06dc9d.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/newOrder.ogg
// module id = 1345
// module chunks = 0